import { EDITBOOK } from "./actionTypes";

const initialState = {};
const editReducer = (state = initialState, action) => {
 switch (action.type) {
  case EDITBOOK:
   const { id, name, author, price, thumbnail, rating, featured } =
    action.payload;
   return {
    ...state,
    id,
    name,
    author,
    price,
    thumbnail,
    rating,
    featured,
   };

  default:
   return state;
 }
};

export default editReducer;
